import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, pluck } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { StoreConfiguration } from '../../interfaces/store-configuration.interface';
import { DomainNameService } from '../domain-name/domain-name.service';

@Injectable({
  providedIn: 'root'
})
export class StoreConfigurationApiService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private domainNameService = inject(DomainNameService);


  url: string;

  constructor() {
    this.url = environment.backendBaseUrl;
  }

  getStoreConfiguration(): Observable<StoreConfiguration | null> {
    const applicationUrl = this.domainNameService.getApplicationUrl();
    // const applicationUrl = "https://placewell.hyperinvento.com";
    // const applicationUrl = "https://www.phototech.co.in";
    // const applicationUrl = "https://www.thereliablestore.com";
    // const applicationUrl = "https://thirdidigital.in";
    // const applicationUrl = "https://imaginext.co.in";
    // const applicationUrl = "https://nikitaretailer.hyperinvento.com";

    // Skip API call if domain is not available (happens during SSR when headers aren't accessible)
    // Client will retry after hydration with proper domain from window.location
    if (!applicationUrl) {
      return of(null);
    }

    const apiUrl = `${this.url}/v2/admin/sales_channel_index/`;

    return this.http.get(apiUrl, {
      params: new HttpParams()
        .set('domain', applicationUrl)
        .set('expand', 'state')
        .set('_source_includes', 'id,company,sales_channel_code,application_configuration,sales_channel_pages,header_configurations.title,header_configurations.favicon,color_configurations,font_configurations') // Only fetch essential fields
    }).pipe(
      pluck('hits', 'hits') as any,
      map((hits: any[]) => {
        const result = hits?.[0]?._source ?? null;
        return result;
      }),
      catchError(_error => {
        // Don't navigate to error page, just return null
        // The app will continue with default configuration
        return of(null);
      })
    );
  }

}
